<template>
  <Grid gap="var(--r-space-md)">
    <Grid gaf="column" align-items="center" justify-content="space-between">
      <div class="text-subtitle-1 text-secondary-2">Email template</div>

      <RDropdown
        v-model="quickviewData.email_template"
        :options="quickviewData.email_templates"
        option-label="name"
        option-value="id"
        label="Select template"
        no-hint
        style="width: 300px"
      />
    </Grid>

    <EmailEditor
      :key="quickviewData.email_template.id"
      :model-subject="quickviewData.email_template.subject"
      :model-content="quickviewData.email_template.body"
      :merge-tags="quickviewData.email_template.merge_tags"
      hide-labels
      @subject-input="quickviewData.email_template.subject = $event"
      @content-input="quickviewData.email_template.body = $event"
    />
  </Grid>
</template>

<script>
import EmailEditor from '@components/editors/EmailEditor'

export default {
  components: {
    EmailEditor
  },

  props: {
    quickviewData: {
      type: Object,
      required: true
    }
  }
}
</script>
